import { render, staticRenderFns } from "./RELViagensCerca.vue?vue&type=template&id=0e7d3932&"
import script from "./RELViagensCerca.vue?vue&type=script&lang=js&"
export * from "./RELViagensCerca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports